{
  "common": {
    "cancel": "取消",
    "save": "保存",
    "delete": "删除",
    "done": "完成",
    "edit": "编辑",
    "search": "搜索",
    "loading": "加载中…",
    "yes": "是",
    "no": "否",
    "settings": "设置",
    "back": "返回",
    "close": "关闭",
    "open": "打开",
    "copy": "复制",
    "restore": "恢复",
    "untitled": "无标题",
    "create": "创建",
    "revoke": "撤销",
    "never": "从不",
    "tryAgain": "重试",
    "reload": "重新加载",
    "update": "更新",
    "insert": "插入",
    "loadingShort": "加载中",
    "unknown": "未知",
    "sampleSentence": "快速的棕色狐狸"
  },
  "sidebar": {
    "views": "视图",
    "tags": "标签",
    "edit": "编辑",
    "done": "完成",
    "account": "账户",
    "newNote": "新建笔记",
    "editTag": "编辑标签",
    "tagOptions": "标签选项",
    "reorder": "重新排序 {{label}}",
    "showView": "显示 {{label}}",
    "hideView": "隐藏 {{label}}",
    "editViews": "编辑视图",
    "doneEditingViews": "完成编辑",
    "samplePeep": "Caliu 是…",
    "sampleQuiet": "让你的思绪自由呼吸的安静空间。"
  },
  "views": {
    "all": "所有笔记",
    "today": "今天",
    "todo": "待办",
    "pinned": "已置顶",
    "untagged": "无标签",
    "thisWeek": "本周",
    "shared": "由我分享",
    "sharedWithMe": "分享给我的",
    "attachments": "附件",
    "trash": "回收站",
    "archive": "已归档"
  },
  "noteList": {
    "empty": "还没有笔记",
    "emptySubtitle": "创建第一条笔记开始使用。",
    "untitled": "无标题",
    "selectNote": "选择一条笔记",
    "selectNoteHint": "从列表中选择一条笔记，或新建一条。",
    "selectRestoreOrDelete": "选择一条笔记以恢复或永久删除",
    "selectSharedToView": "选择一条共享笔记进行查看",
    "searchPlaceholder": "搜索笔记…",
    "selectNotes": "选择笔记",
    "openSidebar": "打开侧边栏",
    "cancelSelection": "取消选择",
    "clearSelection": "清除选择",
    "emptyTrash": "清空回收站",
    "newNote": "新建笔记",
    "noteCount_one": "{{count}} 条笔记",
    "noteCount_other": "{{count}} 条笔记",
    "sortBy": "排序方式",
    "preview": "预览",
    "modificationDate": "修改日期",
    "creationDate": "创建日期",
    "title": "标题",
    "manual": "手动",
    "newestOnTop": "最新在前",
    "small": "小",
    "medium": "中",
    "large": "大",
    "empty_pinned": "还没有置顶笔记",
    "empty_pinned_subtitle": "置顶笔记后可在此处快速找到。",
    "empty_today": "今天没有编辑过",
    "empty_today_subtitle": "今天编辑过的笔记会出现在这里。",
    "empty_todo": "还没有待办",
    "empty_todo_subtitle": "包含未完成任务的笔记会出现在这里。",
    "empty_untagged": "所有笔记都有标签",
    "empty_untagged_subtitle": "没有标签的笔记会出现在这里。",
    "empty_thisWeek": "本周还没有内容",
    "empty_thisWeek_subtitle": "过去7天编辑的笔记会出现在这里。",
    "empty_shared": "没有共享的笔记",
    "empty_shared_subtitle": "你共享的笔记会出现在这里。",
    "empty_attachments": "还没有附件",
    "empty_attachments_subtitle": "带图片或文件的笔记会出现在这里。",
    "justNow": "刚刚",
    "minutesAgo": "{{count}} 分钟前",
    "today": "今天",
    "yesterday": "昨天",
    "deletedOn": "于 {{date}} 删除",
    "newNoteShortcut": "新建笔记 ({{shortcut}})",
    "noContent": "无内容",
    "selectUnarchiveOrDelete": "选择一条笔记以取消归档或删除",
    "view": "视图",
    "density": "密度",
    "exportAll": "全部导出"
  },
  "editor": {
    "attachmentTooLarge": "该文件太大，无法附加。上限为 100 MB。",
    "placeholder": "开始书写…",
    "noMatchingCommands": "没有匹配的命令",
    "newNote": "新建笔记",
    "noResults": "没有结果",
    "foldSection": "折叠章节",
    "unfoldSection": "展开章节",
    "dragSection": "移动章节",
    "presenceLabel": "也在这里: {{names}}"
  },
  "noteActions": {
    "pin": "置顶",
    "unpin": "取消置顶",
    "pinToTop": "置顶",
    "makeReadOnly": "设为只读",
    "makeEditable": "设为可编辑",
    "readOnlyNote": "只读笔记",
    "shareNote": "分享笔记",
    "share": "分享",
    "publiclyShared": "已公开分享",
    "privateNote": "私密笔记",
    "linkCreated": "链接已创建",
    "linkCreatedAndCopied": "链接已创建并复制",
    "linkRevoked": "分享链接已撤销",
    "failedToCreateShareLink": "无法创建分享链接",
    "failedToRevokeShareLink": "无法撤销分享链接",
    "thisNoteIsPrivate": "此笔记为私密。",
    "createPublicLink": "创建公开链接",
    "creatingLink": "正在创建链接…",
    "revokeLink": "撤销链接",
    "revokingLink": "撤销中…",
    "copyLink": "复制链接",
    "copyNoteId": "复制笔记 ID",
    "noteIdCopied": "已复制笔记 ID",
    "exportAs": "导出为",
    "exportMarkdown": "Markdown",
    "exportPlainText": "纯文本",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "导出失败",
    "viewHistory": "查看历史",
    "duplicate": "复制",
    "duplicateFailed": "无法复制笔记",
    "select": "选择",
    "delete": "删除",
    "moveToTrash": "移到回收站",
    "archive": "归档",
    "unarchive": "取消归档",
    "tags": "标签",
    "addTag": "添加标签",
    "noTagsYet": "还没有标签",
    "addTagFailed": "无法添加标签",
    "removeTagFailed": "无法移除标签"
  },
  "userMenu": {
    "theme": "主题",
    "typography": "字体",
    "language": "语言",
    "apiKeys": "API 密钥",
    "devices": "设备",
    "connectedApps": "已连接的应用",
    "help": "帮助",
    "logOut": "退出登录",
    "defaultUserName": "Caliu 用户",
    "editName": "编辑姓名",
    "nameLabel": "姓名",
    "namePlaceholder": "您的姓名",
    "upgradeToPro": "升级到 Caliu Pro",
    "replayOnboarding": "重新观看引导",
    "logOutTitle": "要退出登录吗？",
    "logOutBody": "你的笔记会留在本设备上，仍可继续阅读和编辑。重新登录即可同步。",
    "logOutPending_one": "还有 {{count}} 项更改尚未同步。它会留在本设备上，直到你重新登录。",
    "logOutPending_other": "还有 {{count}} 项更改尚未同步。它们会留在本设备上，直到你重新登录。",
    "logOutKeep": "退出登录",
    "logOutAndRemove": "退出登录并删除笔记"
  },
  "help": {
    "title": "帮助中心",
    "searchPlaceholder": "搜索帮助文章",
    "noResults": "没有符合搜索的文章。",
    "offline": "离线时无法使用帮助。下次联网时将自动加载。"
  },
  "fonts": {
    "uiFont": "界面字体",
    "body": "正文",
    "headings": "标题",
    "code": "代码",
    "sans": "无衬线",
    "serif": "衬线",
    "mono": "等宽",
    "editor": "编辑器",
    "ui": "界面",
    "reset": "恢复默认"
  },
  "themes": {
    "light": "浅色",
    "dark": "深色",
    "system": "跟随系统"
  },
  "languages": {
    "systemHint": "从设备检测",
    "names": {
      "en": "英语",
      "es": "西班牙语",
      "ca": "加泰罗尼亚语",
      "fr": "法语",
      "de": "德语",
      "it": "意大利语",
      "pt": "葡萄牙语",
      "nl": "荷兰语",
      "ja": "日语",
      "zh-CN": "简体中文",
      "ko": "韩语",
      "zh-TW": "繁体中文",
      "ru": "俄语"
    }
  },
  "bulkActions": {
    "pinSelected": "置顶所选",
    "unpinSelected": "取消所选置顶",
    "pin": "置顶",
    "addTag": "添加标签",
    "filterTags": "筛选标签…",
    "noTagsFound": "未找到标签",
    "exportSelected": "导出所选",
    "restoreSelected": "恢复所选",
    "deletePermanently": "永久删除",
    "moveToTrash": "移到回收站",
    "archiveSelected": "归档所选",
    "unarchiveSelected": "取消归档所选",
    "exportingTitle": "正在导出你的笔记",
    "exportingBody": "这可能需要一点时间。请在完成前保持此标签页打开。",
    "exportingProgress": "{{done}} / {{total}}"
  },
  "commandPalette": {
    "placeholder": "搜索笔记、标签、命令…",
    "noResults": "「{{query}}」无结果",
    "currentNote": "当前笔记",
    "navigation": "导航",
    "notes": "笔记",
    "tags": "标签",
    "newNote": "新建笔记",
    "allNotes": "所有笔记",
    "todaysNotes": "今天的笔记",
    "todo": "待办",
    "pinnedNotes": "置顶笔记",
    "trash": "回收站",
    "importNotes": "导入笔记",
    "changeTheme": "更改主题",
    "keyboardShortcuts": "键盘快捷键",
    "pinNote": "置顶笔记",
    "unpinNote": "取消置顶",
    "restoreNote": "恢复笔记",
    "copyShareLink": "复制分享链接",
    "makePrivate": "设为私密",
    "toggleFullscreen": "切换全屏",
    "noteInfo": "笔记信息",
    "moveToTrash": "移到回收站",
    "archiveNote": "归档笔记",
    "unarchiveNote": "取消归档笔记",
    "archive": "已归档"
  },
  "noteHistory": {
    "title": "笔记历史",
    "requiresConnection": "笔记历史需要联网。",
    "reconnect": "请重新连接互联网再试。",
    "noHistory": "此笔记还没有历史。",
    "windowMerged": "5 分钟内的编辑会合并为一条记录。",
    "selectVersion": "选择要预览的版本",
    "encrypted": "加密版本",
    "encryptedHint": "此版本以端到端加密保存。请打开笔记查看当前内容。",
    "restoreVersion": "恢复此版本？",
    "restoreVersionHint": "这将用 {{date}} 的版本替换当前笔记内容。",
    "current": "当前",
    "created": "已创建",
    "trashed": "已删除",
    "restored": "已恢复",
    "edited": "已编辑"
  },
  "apiKeys": {
    "title": "API 密钥",
    "empty": "还没有 API 密钥。",
    "emptyHint": "创建一个以开始使用 API。",
    "created": "创建于 {{date}}",
    "lastUsed": "最近使用: {{date}}",
    "revokeKey": "撤销密钥",
    "viewApiDocs": "查看 API 文档",
    "newApiKey": "新建 API 密钥",
    "apiKeyCreated": "已创建 API 密钥",
    "createApiKey": "创建 API 密钥",
    "copyHint": "请立即复制这个密钥。之后将无法再次查看。",
    "copyToClipboard": "复制到剪贴板",
    "keyName": "密钥名称",
    "keyNamePlaceholder": "例如:我的脚本、Zapier 集成",
    "createKey": "创建密钥",
    "revokeKeyTitle": "撤销 API 密钥",
    "revokeKeyHint": "这将永久撤销此 API 密钥。任何使用它的应用将立即失去访问权限。",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "已连接的应用",
    "empty": "还没有连接的应用。",
    "emptyHint": "连接 Claude、ChatGPT 或其他 AI 助手，即可在聊天中使用你的笔记。具体方法请参阅帮助中的“Caliu 与 AI”部分。",
    "connected": "连接于 {{date}}",
    "lastUsed": "最近使用: {{date}}",
    "revoke": "撤销",
    "revokeTitle": "撤销连接",
    "revokeHint": "这将撤销 <strong>{{name}}</strong> 对你的 Caliu 账户的访问权限，并删除其使用的凭据。它将立即失去访问权限。",
    "thisApp": "此应用",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "写作",
    "metadata": "元数据",
    "words": "字数",
    "characters": "字符",
    "paragraphs": "段落",
    "readTime": "阅读时间",
    "minutes": "{{count}} 分钟",
    "tags": "标签",
    "outgoingLinks": "出链",
    "backlinks": "反链",
    "created": "创建",
    "modified": "修改",
    "noteStatistics": "笔记统计",
    "identifier": "标识符"
  },
  "inspector": {
    "tabInfo": "信息",
    "tabOutline": "大纲",
    "tabHistory": "历史",
    "dates": "日期",
    "noHeadings": "此笔记中没有标题",
    "noBacklinks": "没有笔记链接到这里",
    "noOutgoing": "此笔记未链接到任何内容",
    "noAttachments": "此笔记中没有附件",
    "historyOffline": "版本历史记录需要联网",
    "historyLoadMore": "加载更多"
  },
  "devices": {
    "title": "设备",
    "offline": "你处于离线状态。",
    "offlineHint": "请连接互联网以查看你的设备。",
    "noSessions": "未找到活动会话。",
    "thisDevice": "此设备",
    "lastUsed": "上次使用：{{date}}",
    "created": "创建于：{{date}}",
    "signOutCurrent": "在此设备上退出登录",
    "signOut": "退出登录",
    "confirmCurrentTitle": "在此设备上退出登录吗？",
    "confirmRevokeTitle": "撤销该设备？",
    "confirmCurrentBody": "将在此浏览器中退出 Caliu，并从这台设备上移除笔记。你可以随时重新登录，笔记会从你的账户中恢复。",
    "confirmRevokeBody": "该设备将立即退出登录。在你再次登录之前，未同步的更改将保留在该设备上。",
    "revoke": "撤销"
  },
  "errorScreen": {
    "title": "出错了",
    "defaultMessage": "发生意外错误，请尝试重新加载页面。"
  },
  "importModal": {
    "title": "导入笔记",
    "dropToImport": "松开以导入",
    "dropOrClick": "拖入文件或点击浏览",
    "removeFile": "移除文件",
    "keepNote": "对于 Google Keep，请通过 Takeout 导出 ZIP 并直接上传该压缩包。",
    "importedCount_one": "已导入 <strong>{{count}}</strong> 条笔记",
    "importedCount_other": "已导入 <strong>{{count}}</strong> 条笔记",
    "fromSource": "（来自 {{source}}）",
    "importing": "导入中…",
    "importN": "导入 {{count}} 个文件",
    "importBtn": "导入"
  },
  "share": {
    "shareNote": "分享笔记",
    "publiclySharedAria": "该笔记已公开分享",
    "copyLink": "复制链接",
    "revokingLink": "撤销中…",
    "revokeLink": "撤销链接",
    "creatingLink": "正在创建链接…",
    "createPublicLink": "创建公开链接",
    "shareThisNotePublicly": "公开分享此笔记",
    "thisNoteIsPrivate": "此笔记为私有。",
    "publiclyShared": "公开分享",
    "privateNote": "私有笔记"
  },
  "shortcuts": {
    "searchPlaceholder": "搜索快捷键…",
    "pressNew": "按下新快捷键…",
    "resetToDefault": "恢复默认",
    "noMatches": "没有匹配 “<strong>{{query}}</strong>” 的快捷键",
    "navigate": "导航",
    "edit": "编辑",
    "closeAction": "关闭",
    "resetAll": "全部重置"
  },
  "tagEditor": {
    "icon": "图标",
    "color": "颜色",
    "searchIcons": "搜索图标",
    "noIcons": "没有匹配的图标",
    "categories": {
      "essentials": "常用",
      "work": "工作与科技",
      "ideas": "灵感与创作",
      "life": "人与家庭",
      "travel": "旅行与自然",
      "fun": "美食、健康与娱乐"
    }
  },
  "tagActions": {
    "pin": "置顶标签",
    "unpin": "取消置顶标签",
    "rename": "重命名…",
    "renameTitle": "重命名标签",
    "renameConfirm": "重命名",
    "renameHint": "所有使用该标签的笔记都会更新，包括已归档和回收站中的笔记。",
    "renamed": "标签已重命名",
    "nameInUse": "该名称已被使用",
    "invalidName": "标签名称只能包含字母、数字、空格、连字符和下划线",
    "pinFailed": "无法更新标签",
    "renameFailed": "无法重命名标签",
    "editAppearance": "编辑外观"
  },
  "auth": {
    "appName": "Caliu",
    "or": "或",
    "email": "邮箱",
    "emailPlaceholder": "you@example.com",
    "password": "密码",
    "passwordPlaceholder": "密码",
    "name": "姓名",
    "namePlaceholder": "你的姓名",
    "confirmPassword": "确认密码",
    "newPassword": "新密码",
    "confirmNewPassword": "确认新密码",
    "signInSubtitle": "登录你的账户",
    "createAccountSubtitle": "创建你的账户",
    "forgotPassword": "忘记密码？",
    "signingIn": "正在登录…",
    "signIn": "登录",
    "noAccount": "还没有账户？",
    "signUp": "注册",
    "haveAccount": "已有账户？",
    "creatingAccount": "正在创建账户…",
    "createAccount": "创建账户",
    "googleSignUpAria": "使用 Google 注册",
    "signupClosedTitle": "目前未开放注册",
    "signupClosedBody": "Caliu 处于私测阶段。请在 caliuapp.com 加入等待列表以获得抢先体验。",
    "joinWaitlist": "加入等待列表",
    "forgotTitle": "重置密码",
    "forgotSubtitle": "输入你的邮箱，我们将发送重置链接给你。",
    "sendResetLink": "发送重置链接",
    "sending": "发送中…",
    "checkYourEmail": "请查看你的邮箱",
    "resetLinkSentPrefix": "如果 ",
    "resetLinkSentSuffix": " 已有账户，我们已发送密码重置链接。链接 1 小时内有效。",
    "backToSignIn": "返回登录",
    "verifySentPrefix": "我们已将验证链接发送到 ",
    "verifySentSuffix": "。点击链接以激活你的账户。",
    "linkExpires10m": "链接 10 分钟内有效。",
    "resending": "重新发送中…",
    "resendEmail": "重新发送邮件",
    "wrongEmail": "邮箱不对？",
    "goBack": "返回",
    "invalidResetLinkTitle": "无效的重置链接",
    "invalidResetLinkBody": "此链接无效或已过期。",
    "requestNewLink": "请求新链接",
    "setNewPasswordTitle": "设置新密码",
    "setNewPasswordHint": "请选择高强度密码。",
    "updatingPassword": "更新中…",
    "updatePassword": "更新密码",
    "localNotesTitle": "此设备上有笔记",
    "localNotesBody_one": "登录前你在这里写了 {{count}} 条笔记。要如何处理？",
    "localNotesBody_other": "登录前你在这里写了 {{count}} 条笔记。要如何处理？",
    "localNotesDelete": "删除它们",
    "localNotesMerge": "添加到我的账户",
    "backToMyNotes": "返回我的笔记",
    "errorGoogleAuthFailed": "Google 登录失败。请重试。",
    "errorInvalidToken": "验证链接无效。请重新注册。",
    "errorEmailTaken": "该邮箱已被使用。请登录。",
    "signInInstead": "改为登录该账户",
    "errorIdentityTaken": "该登录方式已绑定到另一个 Caliu 账户。请登录该账户。",
    "parkedNotesTitle": "来自其他账户的笔记",
    "parkedNotesBody_one": "登录 {{email}} 可以把该账户的笔记留在这台设备上。换成其他账户会清除这里唯一的一条笔记，包括之后写的内容。",
    "parkedNotesBody_other": "登录 {{email}} 可以把该账户的笔记留在这台设备上。换成其他账户会清除这里全部 {{count}} 条笔记，包括之后写的内容。",
    "parkedNotesBodyNoEmail_one": "登录你退出的那个账户可以把该账户的笔记留在这台设备上。换成其他账户会清除这里唯一的一条笔记，包括之后写的内容。",
    "parkedNotesBodyNoEmail_other": "登录你退出的那个账户可以把该账户的笔记留在这台设备上。换成其他账户会清除这里全部 {{count}} 条笔记，包括之后写的内容。",
    "parkedNotesContinue": "继续"
  },
  "connectors": {
    "wantsAccess": "想要访问 Caliu",
    "couldntLoad": "无法加载此请求",
    "authorize": "授权",
    "keepHappeningHint": "如果该问题持续，请从你的 MCP 客户端中移除连接器并重新添加。",
    "backToCaliu": "返回 Caliu",
    "askingPermissionPrefix": "请求通过 Caliu 的 MCP 服务器读取和修改你的笔记和标签。",
    "signedInAs": "已以 {{name}} 身份登录。",
    "permissions": "权限",
    "deny": "拒绝",
    "allow": "允许"
  },
  "editorTypography": {
    "fontSize": "字号",
    "lineHeight": "行高",
    "paragraphSpacing": "段落间距"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "撤销",
    "redo": "重做",
    "taskList": "任务列表",
    "bulletList": "项目符号列表",
    "orderedList": "编号列表",
    "blockQuote": "块引用",
    "separator": "分隔符",
    "insertTag": "插入标签",
    "highlight": "高亮",
    "math": "公式",
    "removeHighlight": "移除高亮",
    "inlineCode": "行内代码",
    "codeBlock": "代码块",
    "insertTable": "插入表格",
    "insertImage": "插入图片",
    "hideStyleBar": "隐藏样式栏",
    "attachFile": "附加文件",
    "photoLibrary": "照片图库",
    "camera": "相机",
    "fromFile": "从文件"
  },
  "imageDialog": {
    "title": "插入图片",
    "tabUpload": "文件",
    "tabUrl": "URL",
    "urlLabel": "图片 URL",
    "urlPlaceholder": "https://example.com/image.jpg",
    "altLabel": "替代文字",
    "altPlaceholder": "描述图片…",
    "previewAlt": "预览",
    "changeImage": "更换图片",
    "dropToInsert": "松开以插入",
    "dropOrClick": "拖入图片或点击浏览",
    "formats": "PNG、JPG、GIF、WebP",
    "insert": "插入图片"
  },
  "linkDialog": {
    "editTitle": "编辑链接",
    "insertTitle": "插入链接",
    "textLabel": "文本",
    "textPlaceholder": "链接文本",
    "urlPlaceholder": "https://example.com",
    "removeLink": "移除链接",
    "openLink": "打开链接",
    "editLink": "编辑链接"
  },
  "noteEditor": {
    "notFound": "未找到笔记。",
    "inTrashBanner": "此笔记位于回收站。请先恢复后再编辑。",
    "restore": "恢复",
    "noContent": "此笔记没有内容。"
  },
  "noteHeader": {
    "noteInfo": "笔记信息"
  },
  "table": {
    "deleteRow": "删除行",
    "deleteTable": "删除表格",
    "addRow": "添加行",
    "addRowAbove": "在上方添加行",
    "addColumn": "添加列",
    "addColumnBefore": "在前面添加列",
    "moveRowUp": "上移行",
    "moveRowDown": "下移行",
    "moveColumnLeft": "左移列",
    "moveColumnRight": "右移列",
    "deleteColumn": "删除列",
    "actions": "表格操作"
  },
  "syncIndicator": {
    "synced": "已同步",
    "pending_one": "{{count}} 项待同步",
    "pending_other": "{{count}} 项待同步",
    "offline": "离线",
    "offlinePending_one": "离线 · {{count}} 项待处理",
    "offlinePending_other": "离线 · {{count}} 项待处理",
    "syncing": "正在同步...",
    "conflict_one": "{{count}} 个冲突",
    "conflict_other": "{{count}} 个冲突",
    "error": "同步错误",
    "syncedTooltip": "所有更改已保存",
    "pendingTooltip_one": "{{count}} 项更改等待同步",
    "pendingTooltip_other": "{{count}} 项更改等待同步",
    "offlineTooltip": "离线：重新连接后将同步更改",
    "offlinePendingTooltip_one": "离线：重新连接后将同步 {{count}} 项更改",
    "offlinePendingTooltip_other": "离线：重新连接后将同步 {{count}} 项更改",
    "syncingTooltip": "正在同步...",
    "syncingPendingTooltip_one": "正在同步 {{count}} 项待处理更改...",
    "syncingPendingTooltip_other": "正在同步 {{count}} 项待处理更改...",
    "conflictTooltip_one": "{{count}} 篇笔记存在冲突更改。点击以解决。",
    "conflictTooltip_other": "{{count}} 篇笔记存在冲突更改。点击以解决。",
    "errorTooltip": "同步失败。将自动重试。",
    "conflictsTitle": "解决冲突",
    "local": "在此设备上",
    "localTooltip": "仅保存在此设备上。登录后即可同步。"
  },
  "image": {
    "download": "下载图片",
    "replace": "替换图片",
    "remove": "移除图片"
  },
  "sharePage": {
    "goToCaliu": "前往 Caliu",
    "noteNotFoundTitle": "未找到笔记",
    "somethingWentWrong": "出错了",
    "lastUpdated": "最近更新：{{date}}",
    "tagline": "为思考者打造的笔记应用",
    "subtagline": "用 Markdown 写作。处处同步。思考清晰。",
    "startWriting": "开始写作",
    "signIn": "登录",
    "openInCaliu": "在 Caliu 中打开",
    "adding": "正在添加…",
    "addToSharedList": "添加到我的分享列表",
    "notFoundSubtitle": "此分享链接可能已过期或被撤销。",
    "errorSubtitle": "无法加载此笔记。请重试。"
  },
  "sharedView": {
    "loading": "正在加载分享笔记…",
    "sharedWithYou": "与你共享",
    "viewRaw": "查看原始 Markdown",
    "viewRendered": "查看渲染后的笔记",
    "copyMarkdown": "复制 Markdown",
    "markdownCopied": "已复制 Markdown",
    "copyFailed": "复制失败",
    "notLoadedYet": "此笔记尚未加载完成",
    "linkCopied": "已复制链接",
    "actions": "笔记操作"
  },
  "sharedWithMe": {
    "title": "与我分享",
    "removeFromList": "从列表中移除",
    "empty": "暂无分享给我的笔记",
    "emptyHint": "打开朋友发来的 Caliu 分享链接以将其添加到此处。分享的笔记会在你的设备间同步。"
  },
  "trashView": {
    "empty": "回收站为空",
    "emptyHint": "已删除的笔记将显示在此处",
    "retention": "回收站中的笔记将在 30 天后被永久删除",
    "trash": "回收站"
  },
  "fileAttachment": {
    "download": "下载文件",
    "remove": "删除文件"
  },
  "archiveView": {
    "archive": "已归档",
    "empty": "归档为空",
    "emptyHint": "归档的笔记将显示在这里",
    "archivedOn": "归档于 {{date}}"
  },
  "pro": {
    "subtitle": "Caliu，毫无保留。",
    "features": [
      "无限笔记",
      "笔记版本历史",
      "导出 PDF、HTML、RTF、ePub + 批量",
      "全部主题、字体和应用图标",
      "支持 Caliu 的开发"
    ],
    "perMonth": "每月 {{price}}",
    "perWeek": "每周 {{price}}",
    "oneTime": "一次性付费 {{price}}",
    "perYear": "每年 {{price}}",
    "or": "或",
    "signInToSubscribe": "登录后订阅",
    "accountRequired": "Caliu Pro 与你的账户绑定，因此在所有设备上都能使用。",
    "plansUnavailable": "无法加载订阅方案。请检查网络连接后重试。",
    "yearly": "按年",
    "monthly": "按月",
    "continue": "继续",
    "bestValue": "超值之选",
    "autoRenew": "{{amount}}。在取消前自动续订。可随时取消。",
    "freeTrial": "免费试用 {{count}} 天",
    "billedSubtitle": "免费{{count}}天，之后按{{amount}}扣费。可随时取消。",
    "startTrial": "开始免费试用",
    "upgradeSubtitle": "版本历史、全部主题和字体、导出等更多功能。",
    "upgradeNow": "立即升级",
    "thanks": "感谢你支持 Caliu！",
    "renewsOn": "{{date}} 续订",
    "endsOn": "{{date}} 到期",
    "lifetime": "永久访问",
    "lifetimePlan": "永久",
    "oneTimeNoRenewal": "一次性付款",
    "launchPrice": "首发价。之后将涨至 {{price}}。",
    "buy": "购买",
    "oneTimeDisclosure": "{{amount}}。一次性付款，无需续费。",
    "thanksMessage": "你的支持让 Caliu 保持独立与私密。",
    "manageSubscription": "管理订阅",
    "contactUs": "有疑问？联系我们",
    "grandfatheredNote": "作为早期支持者，Caliu Pro 永久归您所有，无需续订。",
    "webFootnote": "PDF 导出尚未在网页版中提供。",
    "active": "有效"
  },
  "find": {
    "placeholder": "在笔记中查找",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "无结果",
    "next": "下一个匹配",
    "previous": "上一个匹配",
    "close": "关闭"
  },
  "conflicts": {
    "description": "此笔记已在其他设备上被编辑。请保留一个版本。",
    "yours": "你的版本",
    "theirs": "对方的版本",
    "step": "第 {{current}} 个，共 {{total}} 个",
    "keepYours": "保留你的",
    "keepTheirs": "保留对方的",
    "serverError": "无法加载另一个版本。",
    "done": "所有冲突已解决。",
    "previous": "上一个冲突",
    "next": "下一个冲突",
    "copyOf": "{{title}} 的副本"
  },
  "onboarding": {
    "welcomeTitle": "欢迎使用 Caliu",
    "welcomeSubtitle": "让你的思绪安心安住的静谧之地。",
    "getStarted": "开始使用",
    "magicTitle": "看着你的文字成形",
    "magicSubtitle": "你只管写纯文本。Caliu 会把它变成结构:任务、高亮和自动归档的标签。",
    "magicLearnMore": "学习 Markdown 基础",
    "replay": "重播",
    "demoTitle": "海边的夏天",
    "demoBody": "计划在小镇上过一个**慢节奏的星期**。",
    "demoTask": "预订小房子",
    "demoHighlight": "早餐==前==游个泳",
    "demoTags": "#夏天 #计划",
    "intentTitle": "你会在这里记下什么？",
    "intentSubtitle": "选几个吧。你的第一条笔记和标签会在那里等你。",
    "themeTitle": "选择你的光",
    "themeSubtitle": "各式主题，呼应你的写作心境。",
    "proTitle": "从一开始就拥有全部",
    "proSubtitle": "从第一天起就拥有全部功能。先免费试用，觉得值得再留下。",
    "proTrust": "没有广告，没有套路，随时可以取消。",
    "tryProFree": "免费试用 Pro",
    "continueFree": "继续使用免费版",
    "allSetTitle": "一切就绪",
    "allSetSubtitle": "欢迎使用 Caliu。让它成为你的。",
    "startWriting": "开始写作",
    "firstNoteTitle": "一切从这里开始",
    "firstNoteBody": "这是我的第一条笔记。它保存在这台设备上，离线可用，随我到任何地方。",
    "firstNoteTask": "写下一个值得留住的想法",
    "next": "下一步",
    "skip": "跳过",
    "back": "返回",
    "intents": {
      "journal": "日记",
      "ideas": "想法",
      "work": "工作",
      "study": "学习",
      "reading": "阅读",
      "plans": "计划"
    },
    "signInCta": "登录或创建账户",
    "continueWithoutAccount": "不使用账户继续",
    "backupTitle": "你的笔记住在哪里",
    "backupSubtitle": "笔记从这台设备开始。有账户就会同步，安全的副本会到达你的每一台设备。",
    "syncOffTitle": "同步已关闭",
    "syncOffBody": "登录后即可在所有设备上同步笔记。",
    "backupSignedIn": "在你书写的同时，笔记会被安全同步。",
    "backupStageDevice": "此设备",
    "backupStageSafe": "已同步",
    "backupStageEverywhere": "所有设备",
    "freeNotes": "{{limit}} 篇免费笔记，无需账户，永久有效。Pro 版不限数量。"
  },
  "backup": {
    "evictionNotice": "目前笔记仅保存在此浏览器中。空间不足时，浏览器可能会清除站点数据。",
    "dismiss": "关闭",
    "signIn": "登录"
  },
  "gate": {
    "share": "登录后即可分享笔记。",
    "history": "登录后即可保存版本历史。",
    "import": "登录后即可导入笔记。"
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "LaTeX 源码"
  },
  "noteLimit": {
    "banner": "{{count}} / {{limit}} 篇笔记",
    "paywallTitle": "你已用完 {{limit}} 篇免费笔记",
    "paywallBody": "编辑、搜索和同步照常可用。把一篇笔记移到回收站即可腾出名额，或升级 Caliu Pro 解除限制：按月、按年，或一次性买断终身。",
    "importCapped": "只导入了 {{total}} 个文件中的 {{count}} 个：免费版最多可保存 {{limit}} 篇笔记。"
  },
  "appUpdate": {
    "available": "Caliu 有新版本可用。"
  },
  "settings": {
    "title": "设置",
    "account": "账户",
    "writing": "写作",
    "keyboardShortcuts": "键盘快捷键",
    "editor": "编辑器",
    "yourNotes": "你的笔记",
    "about": "关于",
    "noAccount": "无账户",
    "sendFeedback": "发送反馈",
    "signInOrCreate": "登录或创建账户",
    "notesComeWithYou": "此设备上的笔记会随你一起迁移。",
    "notSyncing": "未同步",
    "signInToSync": "登录后即可同步笔记。",
    "sync": "同步",
    "security": "安全",
    "communications": "订阅",
    "newsletter": "Caliu 通讯",
    "newsletterFooter": "偶尔发一封简短的邮件，介绍新版本和 Caliu 即将推出的内容。",
    "newsletterError": "无法更新通讯订阅，请重试。",
    "appearance": "外观",
    "themes": "主题",
    "sizing": "尺寸",
    "systemDefault": "系统默认",
    "separateThemes": "浅色与深色使用不同主题",
    "maxWidth": "最大宽度",
    "maxWidthHint": "在宽屏上将正文居中为易读的栏宽",
    "markdownReturn": "Markdown 风格的回车键",
    "markdownReturnHint": "回车键换行。按两次回车键开始新段落",
    "newNoteStart": "新笔记开头",
    "newNoteStartH1": "标题 1",
    "newNoteStartH2": "标题 2",
    "newNoteStartH3": "标题 3",
    "newNoteStartH4": "标题 4",
    "newNoteStartDate": "日期",
    "newNoteStartDateIso": "日期（ISO 8601）",
    "newNoteStartDateTime": "日期和时间",
    "newNoteStartDateTimeIso": "日期和时间（ISO 8601）",
    "newNoteStartEmpty": "空白",
    "newNoteStartHint": "适用于你在应用中创建的笔记。",
    "collapsibleSections": "可折叠章节",
    "collapsibleSectionsHint": "允许将标题及其内容折叠在箭头后面",
    "experimental": "实验性",
    "general": "通用"
  },
  "toolbar": {
    "toggleSidebar": "显示或隐藏边栏",
    "toggleInspector": "切换检查器",
    "searchNotes": "搜索笔记",
    "newNote": "新建笔记",
    "findInNote": "在笔记中查找",
    "showToolbar": "显示工具栏",
    "hideToolbar": "隐藏工具栏",
    "moreNoteActions": "更多笔记操作",
    "undo": "撤销",
    "redo": "重做",
    "zenMode": "禅模式",
    "sourceMode": "源码模式",
    "richEditor": "富文本编辑器",
    "sortBy": "排序方式",
    "bold": "加粗",
    "italic": "斜体",
    "heading": "标题",
    "list": "列表",
    "link": "链接",
    "insert": "插入",
    "more": "更多",
    "strikethrough": "删除线",
    "table": "表格",
    "horizontalRule": "水平分隔线",
    "codeBlock": "代码块",
    "inlineCode": "行内代码",
    "blockQuote": "引用块",
    "math": "公式",
    "highlight": "高亮",
    "bulletList": "项目符号列表",
    "orderedList": "编号列表",
    "photoLibrary": "照片图库",
    "camera": "相机",
    "files": "文件",
    "yellow": "黄色",
    "green": "绿色",
    "blue": "蓝色",
    "pink": "粉色",
    "purple": "紫色",
    "heading1": "标题 1",
    "heading2": "标题 2",
    "heading3": "标题 3",
    "heading4": "标题 4",
    "heading5": "标题 5",
    "heading6": "标题 6",
    "removeHighlight": "移除高亮"
  },
  "whatsNew": {
    "title": "新功能",
    "tagIconsTitle": "为 Caliu 绘制的图标",
    "tagIconsBody": "应用中的每个图标都是全新的，专为 Caliu 设计。为每个标签设置专属图标，还能用你的语言搜索。",
    "newNoteStartTitle": "按你的方式开始笔记",
    "newNoteStartBody": "新笔记可以从标题、今天的日期、日期和时间或一页空白开始。在“设置”的“编辑器”中选择。",
    "typographyTitle": "精确设置文字",
    "typographyBody": "在“设置”的“字体排印”中，为笔记选择精确的文字大小、行高和段落间距。",
    "typographySample": "每条笔记都会按你设置的字号、行高和间距显示，精确到磅。",
    "sampleMorningPages": "晨间随笔",
    "newsletterTitle": "Caliu 通讯来了",
    "newsletterBody": "从现在起，每次发布都会有一封简短的邮件，用你的语言介绍新功能。想订阅就打开它。你随时可以在设置中更改。"
  },
  "sharing": {
    "inviteByEmail": "通过电子邮件邀请",
    "invite": "邀请",
    "roleOwner": "所有者",
    "roleEditor": "可编辑",
    "roleViewer": "可查看",
    "generalAccess": "常规访问权限",
    "shareWithLink": "通过链接共享",
    "accessRestricted": "仅限受邀者",
    "accessView": "任何拥有链接的人都可查看",
    "accessEdit": "任何拥有链接的人都可编辑",
    "remove": "移除",
    "leave": "退出",
    "leaveNote": "退出笔记",
    "leaveConfirmTitle": "要退出这条笔记吗？",
    "leaveConfirmBody": "它会从你所有设备的列表中消失。所有者可以再次邀请你。",
    "leaveSelectedTitle": "要退出共享笔记吗？",
    "leaveSelectedBody_one": "你将退出 {{count}} 条与你共享的笔记。你自己的笔记会移到回收站。",
    "leaveSelectedBody_other": "你将退出 {{count}} 条与你共享的笔记。你自己的笔记会移到回收站。",
    "sharedBy": "由 {{name}} 共享",
    "sharedList": "已分享",
    "viewOnly": "仅查看",
    "accessNowEditor": "你现在可以编辑这条笔记。",
    "accessNowViewer": "你现在只能查看这条笔记。",
    "accessRemoved": "你已无法访问这条笔记。",
    "unsentSavedAsCopy": "未发送的更改已存为副本。",
    "privateNote": "私密笔记",
    "memberLimit": "一条笔记最多可与 50 人共享。",
    "rateLimit": "邀请过多。请稍后再试。",
    "inviteFailed": "无法发送邀请。请重试。",
    "invalidEmail": "请输入有效的电子邮件地址。",
    "onlineOnly": "连接到互联网以管理共享。",
    "you": "你",
    "ownerOnly": "只有所有者可以更改访问权限。",
    "unavailable": "共享功能暂时不可用。请稍后再试。",
    "updateFailed": "无法更新共享设置。请重试。",
    "inviteInvalid": "此邀请已失效。",
    "copyLink": "复制链接",
    "invited": "已邀请",
    "copied": "已复制",
    "accessRestrictedHint": "只有你邀请的人可以打开。",
    "onlyYouHint": "只有你可以打开。",
    "accessViewHint": "任何拥有链接的人都可以阅读，无需账户。",
    "accessEditHint": "任何拥有链接的人都可以编辑。",
    "roleBelowLink": "任何拥有链接的人都可以编辑，所以你邀请的人也可以编辑。",
    "inviteAs": "邀请身份",
    "revokeInvite": "撤销邀请",
    "statusPeople_one": "{{count}} 人",
    "statusPeople_other": "{{count}} 人",
    "publicLink": "公开链接",
    "statusFrom": "来自 {{name}}",
    "removeConfirmTitle": "要移除 {{name}} 吗？",
    "removeConfirmBody": "对方将无法再访问这条笔记。",
    "revokeConfirmTitle": "要撤销发给 {{name}} 的邀请吗？",
    "revokeConfirmBody": "邀请链接将失效。",
    "peopleWithAccess": "有权访问的成员",
    "addPeoplePlaceholder": "通过电子邮件添加成员",
    "invitePro": "邀请成员是 Caliu Pro 的功能。",
    "inviteKeepsAccess": "即使关闭链接，受邀的人仍可访问。",
    "youSuffix": "（你）"
  },
  "noAccess": {
    "title": "你没有这条笔记的访问权限",
    "linkBody": "所有者没有与你共享它。请让对方邀请你，或打开它的链接。",
    "signedOutBody": "请用共享时使用的账户登录。",
    "inviteTitle": "此邀请已失效",
    "inviteBody": "请向邀请你的人要一个新的邀请。",
    "removedTitle": "你已无法访问这条笔记",
    "removedBody": "所有者已将你移除。",
    "removedCopyBody": "所有者已将你移除。你未发送的更改已作为副本保存在你的笔记中。",
    "backToNotes": "返回笔记",
    "signIn": "登录"
  }
}
